import React from 'react';
import '../styles/Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="home">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Hi, I'm <span className="highlight">Ahmed Hossam Abdelrahman</span></h1>
            <h2>AI / Machine Learning Engineer</h2>
            <p>AI/ML Engineer specializing in production-grade AI systems - LLM-powered applications, multi-agent architectures, and computer vision pipelines. Experienced in RAG, voice AI, and scalable inference. Proficient in Python, PyTorch, LangChain, and LangGraph.</p>
            <div className="hero-buttons">
              <button 
                className="btn btn-primary"
                onClick={() => scrollToSection('projects')}
              >
                View My Work
              </button>
              <button 
                className="btn btn-secondary"
                onClick={() => scrollToSection('contact')}
              >
                Get In Touch
              </button>
            </div>
          </div>
          <div className="hero-image">
            <img src="/Personal-photos/graduation.jpg" alt="Ahmed Hossam abdelrahman" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
